// frontend/src/utils/shareUrl.js
// Centralized share URL construction for sessions

const slugify = (text) =>
  (text || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);

/**
 * Build the best share URL for a session.
 * Prefers clean /@username/slug format when available,
 * falls back to legacy /shared/session/:token/:slug format.
 *
 * @param {Object} session - Session object with shareToken, shareSlug, name
 * @param {string|null} ownerUsername - Owner's username (from session.owner or context)
 * @returns {string} Relative URL path
 */
export function getSessionShareUrl(session, ownerUsername) {
  if (ownerUsername && session.shareSlug) {
    return `/@${ownerUsername}/${session.shareSlug}`;
  }
  // Fallback to legacy URL
  const slug = slugify(session.name);
  return slug
    ? `/shared/session/${session.shareToken}/${slug}`
    : `/shared/session/${session.shareToken}`;
}

/**
 * Build share URL for a project.
 * @param {Object} project - Project object with shareToken, name
 * @returns {string} Relative URL path
 */
export function getProjectShareUrl(project) {
  const slug = slugify(project.name);
  return slug
    ? `/shared/project/${project.shareToken}/${slug}`
    : `/shared/project/${project.shareToken}`;
}

export { slugify };
